export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const env = config.public.env

  if (!['stage', 'prod'].includes(env)) {
    nuxtApp.hook('vue:error', (err, instance, info) => {
      if (import.meta.client) {
        console.log('[vue:error]', err, info)
      } else {
        console.error('[SSR vue:error]', err)
      }
    })
  }
})
